import { get, post } from "../request";
import axios from "axios";
import store from "@/store";

/**
 * @description 库存变动日志 API
 */
export default {
  /**
   * @description 分页查询库存变动日志
   * @param {Object} params {query, changeType, operatorName, pageNum, pageSize, startTime, endTime}
   * @returns Object
   */
  queryChangeLogs(params) {
    return post("/inventory/changeLogs/query", params);
  },

  /**
   * @description 查询历史库存（指定时间点）
   * @param {Object} params {productId, queryTime}
   * @returns Object
   */
  getHistoricalInventory(params) {
    return get("/inventory/changeLogs/historicalInventory", params, true);
  },

  /**
   * @description 批量查询历史库存
   * @param {Object} params {productIds, queryTime}
   * @returns Object
   */
  getBatchHistoricalInventory(params) {
    return post("/inventory/changeLogs/batchHistoricalInventory", params);
  },

  /**
   * @description 统计库存变动
   * @param {Object} params {startTime, endTime, changeType}
   * @returns Object
   */
  getStatistics(params) {
    return get("/inventory/changeLogs/statistics", params, true);
  },

  /**
   * @description 查询异常库存变动
   * @param {Object} params {threshold, startTime, endTime}
   * @returns Object
   */
  getAbnormalChanges(params) {
    return get("/inventory/changeLogs/abnormal", params, true);
  },

  /**
   * @description 导出库存变动日志（Excel）
   * @param {Object} params 查询条件DTO
   * @returns Promise<Blob>
   */
  exportChangeLogs(params) {
    return axios({
      url: store.getters.GET_BASEURL + "/inventory/changeLogs/export",
      method: "post",
      data: params,
      responseType: 'blob',
      headers: {
        "Content-Type": "application/json",
        "Authorization": store.getters.GET_TOKEN,
        "tenantId": store.getters.GET_TENANTID || store.state.tenantId,
      },
    });
  },
};
